// @flow
import { PDFFillerContext } from "pages/Contexts/PdfFillerContext";
import * as React from "react";
import styled from "styled-components";
import type { InputField } from "types/input-field";

import { TriggerUserActions } from "@/components/TriggerUserActions";

const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

type SpanProps = {
  $desiredWidth: number,
  $desiredHeight: number,
};

const StyledSpan = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: transparent;

  input:checked ~ & {
    background-color: #2196f3;
  }

  &:after {
    content: "";
    position: absolute;
    display: none;

    left: ${({ $desiredWidth }: SpanProps) =>
      `calc(50% - ${$desiredWidth / 2}px)`};

    top: ${({ $desiredHeight }: SpanProps) =>
      `calc(50% - ${$desiredHeight / 2}px)`};

    width: ${({ $desiredWidth }: SpanProps) => `${$desiredWidth}px`};

    height: ${({ $desiredHeight }: SpanProps) => `${$desiredHeight}px`};

    border: solid white;
    border-width: ${({ $thickness }: { $thickness: number }) =>
      `0 ${$thickness}px ${$thickness}px 0`};
    transform: rotate(45deg);
  }

  input:checked ~ &:after {
    display: block;
  }
`;

const Container = styled.label`
  flex: 1;
  display: block;
  position: relative;
  cursor: pointer;
  margin: 0;
`;

type Props = {
  disabled?: boolean,
  innerRef: any,
  inputField: InputField,
  onChange: (event: SyntheticEvent<HTMLInputElement>) => void | Promise<void>,
  onFocus: () => void,
};

function CheckboxInput({
  disabled,
  innerRef,
  inputField,
  onChange,
  onFocus,
  ...props
}: Props): React.Node {
  const { answers, zoom } = React.useContext(PDFFillerContext);
  const { height } = inputField;

  return (
    <Container>
      <TriggerUserActions>
        <StyledInput
          checked={answers[inputField.id]?.answer_raw === "true"}
          data-type="document-input"
          disabled={disabled}
          onChange={onChange}
          onFocus={onFocus}
          ref={innerRef}
          type="checkbox"
          {...props}
        />
      </TriggerUserActions>

      <StyledSpan
        $desiredHeight={Math.floor((height / 3) * zoom)}
        $desiredWidth={Math.floor((height / 6) * zoom)}
        $thickness={Math.max(Math.floor((height / 10) * zoom), 1)}
      />
    </Container>
  );
}

CheckboxInput.Label = null;

export default CheckboxInput;
